// Canonical cookie/consent storage — single source of truth for both the consent
// banner (CookieConsent.js) and anything that needs to know the current consent state
// (the AdSense loader). Extracted here so the two never drift on the storage key or
// the "what counts as consent" definition.
const KEY = "msc_cookie_consent";
const CONSENT_CHANGED_EVENT = "mysitecare:consent-changed";

export function getConsentDecision() {
  try {
    return window.localStorage.getItem(KEY); // "accepted" | "rejected" | null (undecided)
  } catch {
    return null; // localStorage unavailable (private mode, blocked, etc.) — treat as undecided
  }
}

export function hasAdvertisingConsent() {
  return getConsentDecision() === "accepted";
}

export function setConsentDecision(value) {
  try {
    window.localStorage.setItem(KEY, value);
  } catch {
    // Ignore — nothing meaningful to do if storage is blocked; the banner will just
    // reappear next visit, which is the safe direction to fail in.
  }
  window.dispatchEvent(new Event(CONSENT_CHANGED_EVENT));
}

export function onConsentChanged(handler) {
  window.addEventListener(CONSENT_CHANGED_EVENT, handler);
  window.addEventListener("storage", handler); // reflects changes made in another tab
  return () => {
    window.removeEventListener(CONSENT_CHANGED_EVENT, handler);
    window.removeEventListener("storage", handler);
  };
}
